<template>
  <i :class="type" :style="{'color': color,
  'font-size': size + 'px',
  'margin-right': right + 'px',
  'margin-left': left + 'px',
   'font-weight': bold ? '600':'500',
   'line-height': lineHeight}" @click="onClick"></i>
</template>

<script>
    export default {
      name: "psimFontIcon",
      props:{
        type:{},
        /*字体图标的颜色*/
        color:{
          type: String,
          default: ''
        },
        /*字体图标的大小*/
        size:{
          type: String,
          default: '16'
        },
        //距右边内容的距离
        'right':{
          type: String,
          default: ''
        },
        //距左边内容的距离
        'left':{
          type: String,
          default: ''
        },
        // 是否字体加粗
        bold:{
          type:Boolean,
          default:false
        },
        'lineHeight':{
          type:Number || String,
          default:1,
        }
      },
      data(){
        return{

        }
      },
      methods:{
        onClick:function(){
          this.$emit('onClick',true);
        },
      },
    }
</script>

<style scoped>
  i{
    color: var(--main-color);
  }
.psim-font{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/psimFontIcon.vue